import {
  Directive,
  ElementRef,
  Host,
  Input,
  OnChanges,
  OnInit,
  Optional,
  Self,
  SimpleChanges,
} from '@angular/core';
import { ILogger, LoggerService } from '@wz-services';
import { isStringNullOrWhiteSpace } from '@wz-utilities/string.utilities';
import { TextInputComponent } from '../../tunnelsante-forms/components/inputs/text-input.component';
import { ResourcesService } from '../../tunnelsante/services/resources/resources.service';

@Directive({
  selector: '[wzI18n]',
  standalone: false,
})
export class ResourceDirective implements OnInit, OnChanges {
  private key!: string;
  private logger: ILogger;

  @Input()
  public set wzI18n(value: string) {
    if (
      this.textInputComponent == null &&
      !isStringNullOrWhiteSpace(this.el.nativeElement.textContent)
    ) {
      this.logger.warn(
        `wzI18n directive overrides ${this.el.nativeElement.textContent}`,
      );
    }

    this.key = value;
  }

  @Input() public wzI18nParams: any | any[];

  constructor(
    private el: ElementRef,
    private resService: ResourcesService,
    logService: LoggerService,
    @Host()
    @Self()
    @Optional()
    private textInputComponent: TextInputComponent,
  ) {
    this.logger = logService.getLogger('i18n-key-directive');
  }

  ngOnInit(): void {
    this.setText();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['wzI18n'] && changes['wzI18n'].firstChange) {
      return;
    }

    this.setText();
  }

  setText() {
    const data = this.resService.getResource(this.key, this.wzI18nParams);
    if (this.textInputComponent) {
      this.textInputComponent.placeholder = data;
    } else {
      this.el.nativeElement.textContent = data;
    }
  }
}
